'use strict';

require('./dataStores');
require('./nav');
require('./map');
require('../shared/contourPreview');
require('./topControls');
require('./webglMap');
require('./invite');
require('./siteSelector');
require('./overlaySelector');
require('./routing');
require('./error');
require('./dialogs');
require('./directives');
require('../shared/pdfPreview');

const dash = angular.module('dash', [
  'dash.routing',
  'dash.map',
  'dash.nav',
  'dash.siteStore',
  'dash.dataCaptureStore',
  'dash.annotationStore',
  'dash.overlayStore',
  'dash.measurementStore',
  'dash.syncStore',
  'dash.planStore',
  'dash.topControls',
  'dash.webglMap',
  'dash.inviteToSite',
  'dash.siteSelector',
  'dash.overlaySelector',
  'dash.pdfPreview',
  'dash.contourPreview',
  'dash.error',
  'dash.dialogs',
  'dash.directives'
]);

// ## Routing
dash.config(require('./DashRoutes'));

// ## Controller
dash.controller('DashController', require('./DashController'));

// ## Service
dash.service('ConversionService', require('./ConversionService'));
dash.service('ShareService', require('./ShareService'));



// WEBPACK FOOTER //
// ./src/app/dash/index.js